import { FieldStatus } from "../types/FieldStatuses";
import { Coordinate, ExtractedCoordinate } from "./extraction/Coordinate";
import { ValidationType } from "./validation/ValidationType";

type ExtractedCellData = {
  fieldName: string;
  fieldValue: string;
  fieldStatus: FieldStatus;
  /** Average OCR Confidence. Default 0 */
  ocrConfidence: number;
  confidence: number;
  transformed: boolean;
  validationTypes: ValidationType[];
  pageId: string;
  spanIds: Array<string>;
} & ExtractedCoordinate;

export default class ExtractedCell implements ExtractedCoordinate {
  fieldName: string;
  fieldValue: string;
  fieldStatus: FieldStatus;
  confidence: number;
  transformed: boolean;
  _validationErrors: Set<ValidationType>;
  pageId: string;
  spanIds: Array<string>;
  /**
   * Ocr Confidence of extraced field. If value is -1, OCR confidence could not be calculated.
   */
  ocrConfidence: number;
  topLeft?: Coordinate;
  bottomRight?: Coordinate;

  get validationTypes(): ValidationType[] {
    return Array.from(this._validationErrors.values());
  }
  get valid(): boolean {
    return (
      this._validationErrors.size === 0 ||
      !this._validationErrors.has("VALIDATION_ERROR")
    );
  }
  get hasOcrWarning(): boolean {
    return this._validationErrors.has("OCR_WARNING");
  }
  set hasOcrWarning(value: boolean) {
    if (!value) {
      this._validationErrors.delete("OCR_WARNING");
    } else {
      this._validationErrors.add("OCR_WARNING");
    }
  }

  constructor(data: ExtractedCellData) {
    this.fieldName = data.fieldName;
    this.fieldValue = data.fieldValue;
    this.fieldStatus = data.fieldStatus;
    this.confidence = data.confidence;
    this.ocrConfidence = data.ocrConfidence ?? -1;

    this.transformed = data.transformed;
    this._validationErrors = new Set(data.validationTypes);

    this.topLeft = data.topLeft;
    this.bottomRight = data.bottomRight;

    this.pageId = data.pageId;
    this.spanIds = data.spanIds;
  }

  static createTest(rest: Partial<ExtractedCellData> = {}): ExtractedCell {
    const data: ExtractedCellData = {
      ocrConfidence: -1,
      confidence: 0,
      fieldName: "",
      fieldStatus: "NO_STATUS",
      fieldValue: "",
      pageId: "",
      spanIds: [],
      transformed: false,
      validationTypes: [],
      topLeft: undefined,
      bottomRight: undefined,
    };
    return new ExtractedCell({
      ...data,
      ...rest,
    });
  }
}

export { ExtractedCell, ExtractedCellData };
